module.exports = __webpack_public_path__ + "static/media/BABY.bb8043f1.svg";